import { MoveStruct, normalizeMoveArguments } from "../utils/index.mjs";
import { KioskOwnerCap } from "./deps/safe/kiosk.mjs";
import { bcs } from "@safecoin/safe/bcs";
//#region src/contracts/kiosk/personal_kiosk.ts
/**************************************************************
* THIS FILE IS GENERATED AND SHOULD NOT BE MANUALLY MODIFIED *
**************************************************************/
/**
* Description: This module provides a wrapper for the KioskOwnerCap that makes the
* Kiosk non-transferable and "owned".
*/
const $moduleName = "@local-pkg/kiosk::personal_kiosk";
const PersonalKioskCap = new MoveStruct({
	name: `${$moduleName}::PersonalKioskCap`,
	fields: {
		id: bcs.Address,
		cap: bcs.option(KioskOwnerCap)
	}
});
new MoveStruct({
	name: `${$moduleName}::Borrow`,
	fields: {
		cap_id: bcs.Address,
		owned_id: bcs.Address
	}
});
new MoveStruct({
	name: `${$moduleName}::OwnerMarker`,
	fields: { dummy_field: bcs.bool() }
});
new MoveStruct({
	name: `${$moduleName}::NewPersonalKiosk`,
	fields: { kiosk_id: bcs.Address }
});
/**
* Wrap the KioskOwnerCap making the Kiosk "owned" and non-transferable. The
* `PersonalKioskCap` is returned to allow chaining within a PTB, but the value
* must be consumed by the `transfer_to_sender` call in any case.
*/
function _new(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null, null];
	const parameterNames = ["kiosk", "cap"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "personal_kiosk",
		function: "new",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames)
	});
}
/**
* Borrow the `KioskOwnerCap` from the `PersonalKioskCap` object; `Borrow`
* hot-potato makes sure that the Cap is returned via `return_val` call.
*/
function borrowVal(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null];
	const parameterNames = ["self"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "personal_kiosk",
		function: "borrow_val",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames)
	});
}
/** Return the Cap to the PersonalKioskCap object. */
function returnVal(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [
		null,
		null,
		null
	];
	const parameterNames = [
		"self",
		"cap",
		"borrow"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "personal_kiosk",
		function: "return_val",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames)
	});
}
/** Transfer the `PersonalKioskCap` to the transaction sender. */
function transferToSender(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null];
	const parameterNames = ["self"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "personal_kiosk",
		function: "transfer_to_sender",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames)
	});
}
//#endregion
export { PersonalKioskCap, _new, borrowVal, returnVal, transferToSender };

//# sourceMappingURL=personal_kiosk.mjs.map